module.exports = __webpack_public_path__ + "img/borussia3.4757d2e2.jpg";